import React from "react";
import { useSelector } from "react-redux";
import Button from "../../../../../../common/Button";
import Title from "../../../../../learning/presentational/body/view/directive/Title";
import Tip from "./Tip";

const Directive = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  return (
    <div className="learning_head">
      <div className="mathQuest-wrap">
        <Title>{ answeringQuestions.data.textCn }</Title>
        <Button className="note_btn">연습장</Button>
        <Tip />
      </div>
    </div>
  );

};

export default Directive;
